import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import PersonEditor from "../person-editor";

const ContactPersonsCreate = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neue Person erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <PersonEditor />
      </div>
    </div>
  );
};

export default ContactPersonsCreate;
